import { render, staticRenderFns } from "./salesSummaryLeader.vue?vue&type=template&id=047fb75a&scoped=true&"
import script from "./salesSummaryLeader.vue?vue&type=script&lang=js&"
export * from "./salesSummaryLeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047fb75a",
  null
  
)

export default component.exports